export default __webpack_public_path__ + "static/media/icn-wtd-parking-break.687ee859.svg";